import React, { useState, useEffect, useMemo } from 'react';
import { Input } from 'antd';
import debounce from 'lodash/debounce';

const DebouncedInput = ({
  value: propValue = '',
  onChange,
  debounceTimeout = 300,
  ...restProps
}) => {
  const [localValue, setLocalValue] = useState(propValue);

  // Create debounced callback
  const debouncedOnChange = useMemo(
    () => debounce(onChange, debounceTimeout),
    [onChange, debounceTimeout]
  );

  // Handle input changes
  const handleChange = (e) => {
    const newValue = e.target.value;
    setLocalValue(newValue); // Update local state immediately
    debouncedOnChange(newValue); // Debounce the parent callback
  };

  // Sync with external value changes
  useEffect(() => {
    setLocalValue(propValue);
  }, [propValue]);

  // Cleanup
  useEffect(() => {
    return () => {
      debouncedOnChange.cancel();
    };
  }, [debouncedOnChange]);

  return (
    <Input
      {...restProps}
      value={localValue}
      onChange={handleChange}
    />
  );
};

export default DebouncedInput;